import React from 'react';
import PropTypes from 'prop-types';
import MuiTab from '@material-ui/core/Tab';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from './IconButton';

const useCustomStyles = makeStyles(() => ({
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
  },
}));
const styles = () => ({
  root: {},
  wrapper: {
    textTransform: 'none',
  },
  tabCloseButton: {}, // This is passed from above, needs to be stripped out before classes are passed into the Mui Tab
});
const Tab = React.forwardRef((props, ref) => {
  const {
    classes,
    label,
    onClose,
    onContextMenu,
    value,
    ...rest
  } = props;

  const customClasses = useCustomStyles();
  const {
    tabCloseButton: tabCloseButtonClass,
    ...restClasses
  } = classes;
  return (
    <MuiTab
      {...rest}
      classes={restClasses}
      component="div"
      ref={ref}
      label={(
        <span className={customClasses.label}>
          {label}
          {onClose && (
          <IconButton
            classes={{
              root: tabCloseButtonClass,
              tooltip: customClasses.closeButton,
            }}
            color="inherit"
            title="Close Tab"
            icon={CloseIcon}
            onClick={(evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              onClose(value);
            }}
            size="small"
          />
          )}
        </span>
                )}
      onContextMenu={onContextMenu}
      value={value}
    />
  );
});
Tab.defaultProps = {
  onClose: null,
  onContextMenu: null,
};
Tab.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onContextMenu: PropTypes.func,
};
export default withStyles(styles)(Tab);
